import type { RunnerContext } from './types';

/**
 * Uploads any of the brand's product images that don't yet have a Replicate URL,
 * caches the URL on the row, and returns the URLs in row order. When
 * `productImageIds` is given, the result is filtered to that subset; otherwise
 * all of the brand's product images are returned.
 */
export async function uploadProductImages(
  ctx: RunnerContext,
  brandId: string,
  productImageIds?: readonly string[],
): Promise<string[]> {
  const allRows = await ctx.db.productImages.where('brandId').equals(brandId).toArray();
  const idFilter =
    productImageIds && productImageIds.length > 0 ? new Set(productImageIds) : null;
  const rows = idFilter ? allRows.filter((r) => idFilter.has(r.id)) : allRows;
  for (const row of rows) {
    if (row.uploadedReplicateUrl) continue;
    const file = await ctx.client.uploadFile(row.blob, row.filename, ctx.signal);
    await ctx.db.productImages.update(row.id, { uploadedReplicateUrl: file.urls.get });
    row.uploadedReplicateUrl = file.urls.get;
  }
  return rows
    .map((r) => r.uploadedReplicateUrl)
    .filter((u): u is string => Boolean(u));
}
